import React from 'react'
import { makeStyles, Box, Typography } from '@material-ui/core'
import { useHistory } from 'react-router-dom'
import { ContainedButton, OutlinedButton } from '../components/buttons/Buttons'
import heroImage from "../images/heroImage.png"
import publicStyles from "../../../../layouts/PublicLayout.module.css"

const useStyles = makeStyles((theme) => ({
    heroSection: {
        minHeight: "613px",
        height: "613px",
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        padding: "80px 24px",
        backgroundColor: "#111111",
        boxSizing: "border-box",
        border: "none",
        outline: "none",
        [theme.breakpoints.down('sm')]: {
            padding: "40px 16px",
            minHeight: "424px",
            height: "424px",
        },
        position: 'relative',
        marginTop: 0,
        overflow: 'hidden',
        "&::after": {
            content: '""',
            position: "absolute",
            top: -2,
            left: -2,
            right: -2,
            bottom: -2,
            backgroundColor: "rgba(17, 17, 17, 0.75)",
            zIndex: 1,
        },
    },
    heroVideo: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        width: '100%',
        height: '100%',
        transform: 'translate(-50%, -50%)',
        objectFit: 'cover',
        zIndex: 0,
    },
    heroSectionContainer: {
        zIndex: 2,
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        maxWidth: 1314,
        width: '100%',
    },
    heroTitle: {
        fontFamily: '"Cormorant Garamond", serif',
        fontSize: '64px',
        fontWeight: 400,
        marginBottom: "24px",
        lineHeight: '100%',
        [theme.breakpoints.down('sm')]: {
            lineHeight: 1,
            fontSize: '44px'
        },
    },
    heroTitleItalic: {
        fontStyle: 'italic',
    },
    heroSubtitle: {
        fontSize: '18px',
        fontWeight: 200,
        maxWidth: 720,
        marginBottom: "40px",
        lineHeight: "27px",
        color: "#ffffff",
        textAlign: "center",
        [theme.breakpoints.down('sm')]: {
            lineHeight: '24px',
            fontSize: '16px'
        }
    },
    heroButtons: {
        display: 'flex',
        gap: theme.spacing(2),
        flexWrap: 'wrap',
        justifyContent: 'center',
        width: '100%',
        [theme.breakpoints.down('sm')]: {
            flexDirection: 'column',
            gap: theme.spacing(1.5),
            alignItems: 'stretch',
            width: '100%',
            padding: theme.spacing(0, 2),
        }
    },
    fullWidthBtn: {
        [theme.breakpoints.down('sm')]: {
            width: '348px !important',
            maxWidth: '100% !important',
            height: '38px',
            padding: '16px 32px',
            borderRadius: '6px !important',
        }
    }
}))

export const HeroSection: React.FC = () => {
    const classes = useStyles()
    const history = useHistory()
    return (
        <Box className={classes.heroSection}>
            <video
                autoPlay
                loop
                muted
                playsInline
                className={classes.heroVideo}
                poster={heroImage}
            >
                <source src="https://files.catbox.moe/ejsxhp.mp4" type="video/mp4" />
            </video>
            <Box className={classes.heroSectionContainer}>
                <Typography variant="h1" className={classes.heroTitle}>
                    The inner circle awaits. <span className={classes.heroTitleItalic}></span>
                </Typography>
                <Typography className={classes.heroSubtitle}>
                    Mainstream platforms are a race to the bottom. Step behind the velvet rope. SugarCribs is the invite-only
                    platform for discovering premium creators in a curated, private, and luxury environment.
                </Typography>
                <Box className={classes.heroButtons}>
                    <ContainedButton text="Request Member Access" styles={`${publicStyles.roundedBtn} ${classes.fullWidthBtn}`} onClick={() => history.push('/login')} />
                    <OutlinedButton text="Apply As Creator" styles={`${publicStyles.roundedBtn} ${classes.fullWidthBtn}`} onClick={() => history.push('/apply-as-creator')} />
                </Box>
            </Box>
        </Box>
    )
}
